export const LINQ_STATUS = {
    LinqUserMessageException: 460,
    PostingOverDrawnException: 461,
    InvalidUserAuthCode: 462,
};
